module.exports = __webpack_public_path__ + "img/bx-6.adb09dff.jpg";